import { useContext } from "react";

import { NcGlobalContext } from "./nc-global-context";

export const useI18n = () => {
  const { t, locale } = useContext(NcGlobalContext);
  return { t, locale };
};
